import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ff } from '../../../theme';

const BrandManagedSchedulingNotice: React.FC = () => (
  <Flex
    role="status"
    direction="column"
    gap="4px"
    p="14px"
    borderRadius="16px"
    bg={ff.grey}
    onClick={(e) => e.stopPropagation()}
  >
    <Text as="strong" fontSize="15px" lineHeight="normal">Brand sets your due date</Text>
    <Text fontSize="14px" lineHeight={1.4} color={ff.body}>
      Communicate with the brand to coordinate collab scheduling and content due dates.
    </Text>
  </Flex>
);

export default BrandManagedSchedulingNotice;
